import TransferList from '@/components/Transfer/TransferList'
import TransferForm from '@/components/Transfer/TransferForm'
import TransferDetail from '@/components/Transfer/TransferDetail'

let TransferRouter = [{
  path: '/transfer',
  name: 'TransferList',
  component: TransferList,
  meta: {
    title: 'Demandes de transfert',
    requiresAuth: true,
    authorizations: ['transfer_index', 'desktop_access']
  }
}, {
  path: '/transfer/status/:status',
  name: 'TransferListByStatus',
  component: TransferList,
  meta: {
    title: 'Demandes de transfert',
    requiresAuth: true,
    authorizations: ['transfer_index', 'desktop_access']
  }
}, {
  path: '/transfer/new',
  name: 'TransferNew',
  component: TransferForm,
  meta: {
    title: 'Nouvelle demande de transfert',
    requiresAuth: true,
    authorizations: ['transfer_new', 'desktop_access']
  }
}, {
  path: '/transfer/:id/edit',
  name: 'TransferEdit',
  component: TransferForm,
  meta: {
    title: 'Modifier une demande de transfert',
    requiresAuth: true,
    authorizations: ['transfer_edit', 'desktop_access']
  }
}, {
  path: '/transfer/:id',
  name: 'TransferDetail',
  component: TransferDetail,
  meta: {
    title: 'Fiche demande de transfert',
    requiresAuth: true,
    authorizations: ['transfer_show', 'desktop_access']
  }
}]

export default TransferRouter



// WEBPACK FOOTER //
// ./src/components/Transfer/router.js